import { Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { NoResultsImage2 } from 'Images';

export const NoRecentOrdersFound = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Treatment);
  return (
    <NoDataFound2
      gap='32px'
      headerComponent={
        <Stack gap='8px' alignItems={'center'} mt='32px'>
          <Typography
            variant='h3'
            color='text.secondary'
            alignSelf={'center'}
            component={'h2'}
          >
            {dictionary.recentOrders.noData}
          </Typography>
        </Stack>
      }
      image={NoResultsImage2}
      extraText={dictionary.notEntitled.labels.subtitle2}
      redirects={dictionary.notEntitled.redirects}
    />
  );
};
